import { useCallback } from 'react';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';
import {
  HomePageEventLabels,
  HomePageEventsMap,
  type TrackHomePageEvent,
} from './events';

/**
 * Custom hook to handle home page tracking events
 */
export function useTrackHomePageAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackHomePageEvent, extra?: Record<string, unknown>) => {
      const eventLabel = HomePageEventLabels[event];
      const eventInfo = HomePageEventsMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
